<template>
	<img src="@/assets/Dashboard_icon.svg" />
</template>